import Head from 'next/head'

import Accordion from '@totallymoney/ui/components/Accordion'
import Box from '@totallymoney/ui/components/Box'
import Heading from '@totallymoney/ui/components/Heading'
import Stack from '@totallymoney/ui/components/Stack'

import useAppQueryState from '@hooks/useAppQueryState'

import convertJsxToPlainText from '@utils/convertJsxToPlainText'

import { faqsList } from './lib/faqsList'

const FaqsSection = () => {
    const { appQueryState } = useAppQueryState()
    const category = appQueryState.categoryId!

    const faqs = faqsList[category]

    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            '@context': 'https://schema.org',
                            '@type': 'FAQPage',
                            mainEntity: faqs.map(({ heading, text }) => ({
                                '@type': 'Question',
                                name: heading,
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: convertJsxToPlainText(text),
                                },
                            })),
                        }),
                    }}
                />
            </Head>

            <Box gridColumn={['1/13', '1/13', '2/12']} id="faqs">
                <Box mb="space40">
                    <Heading variant="100">Credit card FAQs</Heading>
                </Box>

                <Stack space="space20">
                    {faqs.map(({ heading, text }, i) => (
                        <Accordion
                            // @ts-ignore
                            style={{ backgroundColor: 'white' }}
                            header={heading}
                            key={`${heading}-${i}`}
                            initialIsOpen={i === 0}
                        >
                            {text}
                        </Accordion>
                    ))}
                </Stack>
            </Box>
        </>
    )
}

export default FaqsSection
